import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from '../../../../@core/service/api.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { CompilationModel, PaymentPlan, PaymentPlanInvoice, PaymentPlanItem } from '../../../../@models/erp/compilation';
import { TreeService } from '../../../../@core/service/tree.service';
import { NbPopoverDirective } from '@nebular/theme';
import { PaymentDates } from '../../../../@models/erp/compilationData';
import { getTotalNet } from '../../../../@core/common/global';

@Component({
  selector: 'ngx-payment-plan',
  templateUrl: './payment-plan.component.html',
  styleUrls: ['./payment-plan.component.scss'],
})
export class PaymentPlanComponent implements OnInit {
  @Input() compilation: CompilationModel;
  @Input() disabled: boolean = false;
  @Input() print: boolean = false;
  @Input() profitMargin = false;

  @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;
  hidePopovers = () => this.popovers && this.popovers.forEach(el => el.hide());

  paymentDateOptions = PaymentDates.getOptions();

  // termsOfPaymentOptions: { id: string, name: string }[]

  constructor(private api: ApiService, private domSanitizer: DomSanitizer, public data: SharedDataService, protected tree: TreeService) {
  }

  async ngOnInit() {
    if (!this.compilation.paymentPlan) {
      this.compilation.paymentPlan = new PaymentPlan();
    }
    if (!this.compilation.paymentPlan.items.length) {
      this.compilation.paymentPlan.items = [new PaymentPlanItem()];
      this.compilation.paymentPlan.items[0].percent = '100';
      this.compilation.paymentPlan.items[0].paymentDate = this.compilation.expectedNextInvoiceDate;
      this.compilation.paymentPlan.items[0].text = this.compilation.paymentPlan.text;
      this.compilation.paymentPlan.items[0].termsOfPayment = this.compilation.paymentPlan.termsOfPayment;
      this.compilation.paymentPlan.items[0].plannedValue = this.data.totalNet;
    }
    // const cd = await this.api.getCompilationData();
    // this.termsOfPaymentOptions = cd.termsOfPaymentStore.map(m => ({ id: m, name:m }))
    // console.log('disabled', this.disabled);
  }

  addItem() {
    console.log('add payment lan item');
    const paymentPlanItem = new PaymentPlanItem();
    this.compilation.paymentPlan.items.push(paymentPlanItem);
    console.log('payment plan item added', paymentPlanItem, this.compilation.paymentPlan);
  }

  removeItem(idx: number) {
    this.compilation.paymentPlan.items.splice(idx, 1);
  }

  checkValid() {
    return typeof(this.compilation.paymentPlan) !== 'string';
  }

  termsOfPaymentChanged(item, terms: string) {
    item.termsOfPayment = terms;
  }

  sanitize(value: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(value?.replace(/\n/g, '<br>'))
  }

  // addInvoice(item: PaymentPlanItem) {
  //   const ppIn = new PaymentPlanInvoice();
  //   if (!item.invoices) item.invoices = [];
  //   item.invoices.push(ppIn);
  // }

  setPaymentPlanInvoice(item: PaymentPlanItem, inv: any) {
    console.log('invoice', inv);
    const ppIn = new PaymentPlanInvoice();
    if (!item.invoices) item.invoices = [];
    ppIn.code = inv.doc.code;
    ppIn.paymentType = inv.doc.invoicePayment;
    ppIn.issueDate = inv.doc.issueDate;
    ppIn.baseProduct = null;
    ppIn.net = /^CNNRK/.test(inv.doc.code) ? Math.abs(inv.doc.sumTotal) : -Math.abs(inv.doc.sumTotal);
    ppIn.paymentStatus = inv.doc.invoiceStatus;
    ppIn.paymentDate = undefined;
    item.invoices.push(ppIn);
    this.hidePopovers();
  }

  removePaymentInvoice(item: PaymentPlanItem, inv: any) {
    item.invoices = item.invoices.filter(f => f !== inv);
  }

  totalPercent() {
    if (!this.compilation.paymentPlan?.items?.length) return 100;
    return this.compilation.paymentPlan?.items?.reduce((a, c) => a + (+(''+c.percent)?.replace(/%/,'')), 0);
  }

  getCalculatedValue(item: PaymentPlanItem) {
    const net = this.compilation?.lineItems?.reduce((a, c) => a + c.quantity * c.piecePrice, 0)
      - Math.abs(this.compilation.deductibleItems?.reduce((a, c) => a + c.value, 0))
    const percent = +(item.percent + '').replace(/[^0-9.,eE]/g, '')
    // console.log('getCalculatedValue', this.data.totalNet, net, item.percent, percent)
    return net * percent / 100;
  }

  // async addTermsOfPayment(item: PaymentPlanItem) {
  //   // eslint-disable-next-line max-len
  //   const cd = await this.api.saveCompilationData('termsOfPaymentStore', item.termsOfPayment, true);
  //   this.termsOfPaymentOptions = cd.termsOfPaymentStore.map(m => ({ id: m, name:m }))
  // }

  // async removeTermsOfPayment(item: PaymentPlanItem) {
  //   // eslint-disable-next-line max-len
  //   const cd = await this.api.saveCompilationData('termsOfPaymentStore', item.termsOfPayment, false);
  //   this.termsOfPaymentOptions = cd.termsOfPaymentStore.map(m => ({ id: m, name:m }))
  // }

  copyToClipboard() {

    this.data.copyHtmlToClipboard(this.getClipboardPaymentHtml());

  }

  getClipboardPaymentHtml() {
    let html = `
    <div>
      <div><b>Payment Plan</b></div>
      <div>&nbsp;</div>
      <div><b>${this.compilation.code}</b></div>
      <table cellspacing="0" style="border-collapse:collapse;">
        <tr>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Pos</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">%</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Payment Schedule / Schedule Details</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Terms of Payment</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Period of Payment</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">IN Date</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Value</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Currency</th>
        </tr>`

        this.compilation.paymentPlan.items.forEach((item, idx) => {
          html += `
          <tr style="border: 1px solid black">
            <td style="border:1px solid black;text-align:center;padding:5px">${(idx+1).toString().padStart(2, '0')}</td>
            <td style="border:1px solid black;text-align:center;padding:5px">${item.percent}</td>
            <td style="border:1px solid black;text-align:left;padding:5px;white-space:pre-wrap">${item.textPrefix?.trim() + (item.scheduleDetails ? '\n' + item.scheduleDetails?.trim() : '')}</td>
            <td style="border:1px solid black;text-align:left;padding:5px">${item.text}</td>
            <td style="border:1px solid black;text-align:left;padding:5px">${item.termsOfPayment}</td>
            <td style="border:1px solid black;text-align:center;padding:5px">${
              item.invoices?.length
              ? item.invoices.map(m => (m.issueDate as any)?.replace(/T.*/, '')).join('<br>')
              : (this.compilation[item.paymentDateRef] as any || item.paymentDate)?.replace(/T.*/, '') || ''
            }</td>
            <td style="border:1px solid black;text-align:right;padding:5px">${
              item.invoices?.length
              ? item.invoices.map(m => Math.abs(m.net)).join('<br>')
              : Math.abs(item.plannedValue) || ''
            }</td>
            <td style="border:1px solid black;text-align:left;padding:5px">${this.compilation.currency}</td>
          </tr>`
        });
    
        html += `
      </table>
    </div>`

    return html;
  }

  movePaymentUp(idx: number) {
    const current = this.compilation.paymentPlan.items.splice(idx, 1)[0];
    this.compilation.paymentPlan.items.splice(idx-1, 0, current);
  }

  movePaymentDown(idx: number) {
    const current = this.compilation.paymentPlan.items.splice(idx, 1)[0];
    this.compilation.paymentPlan.items.splice(idx+1, 0, current);
  }



}
